import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpService } from './http.service';
// import { Routes } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { tap, catchError, map } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorHandlerComponent } from '../component/error-handler/error-handler.component';
// import 'rxjs/add/operator/toPromise';
import { Occupation, DialogData } from '../model/data.model';
import apiUrlPoint from '../life-config/apiEndPoints.json';
@Injectable({
    providedIn: 'root'
})
export class ApiService {
    uuid: string;
    proposalId: string;
    urlSplit: any;
    modalStatus: boolean;
    apiInitial = apiUrlPoint.apiEndPoints;
    statusObtained:any;

    /**
     * Status error message
     */

    getStatusEvent: Subject<any> = new Subject();
    getModalStatus: Subject<any> = new Subject();

    constructor(

        private httpService: HttpService,
        private loader: LoaderService,
        private activatedRoute: ActivatedRoute,
        private route: ActivatedRoute,
        public dialog: MatDialog
    ) { }


    setStatusEvent(addOnDataEmiited: any) {
        this.statusObtained = addOnDataEmiited;
        this.getStatusEvent.next(addOnDataEmiited);


    }

    setModalInfo(valueObtained) {

        this.modalStatus = valueObtained;
    }

    // get config data = It needs to be in sync as data will required to load nad
    getConfigInfo(urlObtained: string) {
        return this.httpService.getConfigInfo(urlObtained)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    // Get Utils

    getUtilsInfo(urlObtained: string, inusrerCode: string, productName: string, queryParamsURL: string) {
        return this.httpService.geUtilsWithQueryParms(urlObtained, inusrerCode, productName, queryParamsURL)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    getUtilsWithutInsurerCode(urlObtained: string, queryParamsURL: string) {

        return this.httpService.geUtilsWithoutInsurer(urlObtained, queryParamsURL)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );

    }
    // get Utils without insurer info

    getUtilsInfoWithoutInsurerQuery(urlObtained: string, queryParamsURL: string) {
        return this.httpService.geUtilsWithoutInsurer(urlObtained, queryParamsURL)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    // get utils with Previous Info

    getUtilsInfoWithPrvID(urlObtained: string, queryParamsURL: string, secondQueryParms: string, secondQueryParamsVal: string | number) {
        return this.httpService.getUtilsWithPrvInfo(urlObtained, queryParamsURL, secondQueryParms, secondQueryParamsVal)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    // get Utils with insurer
    // tslint:disable-next-line: max-line-length
    getUtilsInfoWithPrvIDInsurer(urlObtained: string, inusrerCode: string, productName: string, queryParamsURL: string, secondQueryParms: string, secondQueryParamsVal: string | number) {
        // tslint:disable-next-line: max-line-length
        return this.httpService.getUtilsWithPrvInfoInusrer(urlObtained, inusrerCode, productName, queryParamsURL, secondQueryParms, secondQueryParamsVal)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    getPincodeForSuitabilityAnalysis(urlObtained: string, inusrerCode: string, productName: string, queryParamsURL: string, secondQueryParms: string, secondQueryParamsVal: string | number) {
        // tslint:disable-next-line: max-line-length
        return this.httpService.getPincodeForSuitabilityAnalysis(urlObtained, inusrerCode, productName, queryParamsURL, secondQueryParms, secondQueryParamsVal)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }


    getBIWithInsurer(
        urlObtained: string, uuid: string, inusrerName: string, productName: string, queryParamsURL: string, proposalID: string) {
        // tslint:disable-next-line: max-line-length
        return this.httpService.geUtilsWithQueryParms(urlObtained, inusrerName, productName, queryParamsURL, uuid, proposalID)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }


    // Get Quote URL

    getPropsalInfo(urlObtained: string, proposalId: string, uuid: string, queryParamsURL: string): Observable<any> {

        return this.httpService.getRequestWithParams(urlObtained, proposalId, uuid, queryParamsURL)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    getPropsalInfoWithoutQueryParms(urlObtained: string, proposalId: string, uuid: string) {
        return this.httpService.getRequestWithoutParams(urlObtained, proposalId, uuid)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }



    postIntiateQuote(urlObtained: string, proposalId: string, uuid: string, queryParamsURL: string, extraQueryParams: string) {

        if (extraQueryParams) {
            return this.httpService.postRequestWithExtraParams(urlObtained, proposalId, uuid, queryParamsURL, extraQueryParams)
                .pipe(
                    map(response => response),
                    catchError(err => JSON.stringify(this.errorHandler(err)))
                );
        } else {

            return this.httpService.postRequestWithoutData(urlObtained, proposalId, uuid, queryParamsURL)
                .pipe(
                    map(response => response),
                    catchError(err => JSON.stringify(this.errorHandler(err)))
                );
        }


    }


    // UpdateProposal

    updateProposal(urlObtained: string, proposalId: string, uuid: string, queryParamsURL: string, data: any) {

        return this.httpService.patchRequestWithProposal(urlObtained, proposalId, uuid, queryParamsURL, data)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    /**
     * TODOs -make a generalize method for Post to send data
     */

    // Post Method without any data

    postWithoutData(urlObtained: string, proposalId: string, uuid: string, queryParamsURL: string) {

        return this.httpService.postRequestWithoutData(urlObtained, proposalId, uuid, queryParamsURL)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    /**
     * Post wiith data
     * remove this later as it is not generic
     */

    postWithData(urlObtained: string, proposalId: string, uuid: string, queryParamsURL: string, data?: any, extraQueryParmsUrl?: string,) {
        if (extraQueryParmsUrl) {

            return this.httpService.postDataWithProposal(urlObtained, proposalId, uuid, queryParamsURL, data, extraQueryParmsUrl)
                .pipe(
                    map(response => response),
                    catchError(err => JSON.stringify(this.errorHandler(err)))
                );

        } else {

            return this.httpService.postDataWithProposal(urlObtained, proposalId, uuid, queryParamsURL, data)
                .pipe(
                    map(response => response),
                    catchError(err => JSON.stringify(this.errorHandler(err)))
                );
        }
    }

    // Document list
    postDocumentData(urlObtained: string, proposalId: string, uuid: string, queryParamsURL: string, data: any) {

        return this.httpService.postRequestDocumentData(urlObtained, proposalId, uuid, queryParamsURL, data)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    // tslint:disable-next-line: max-line-length
    deleteDocumentData(urlObtained: string, proposalId: string, uuid: string, queryParamsURL: string, doc_type: string | number, proof_type: string | number, doc_id: string | number) {

        return this.httpService.deleteRequestuploadData(urlObtained, proposalId, uuid, queryParamsURL, doc_type, proof_type, doc_id)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(err))
            );
    }


    getDocumentUploadedData(urlObtained: string, proposalId: string, uuid: string, queryParamsURL: string) {
        return this.httpService.getRequestUploadData(urlObtained, proposalId, uuid, queryParamsURL)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(err))
            );
    }

    getUtilsInfoWithoutInsurerQueryUpdated(urlObtained: any) {
        return this.httpService.GetRequest(urlObtained)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }


    /**************************************Removing in time above api call************************************************************* */


    /**
     *  Removing old strurcture as it is not being suppourted
     *
     */


    private setUrlWithPrefix(subUrlKey: string) {
        return this.apiInitial['apiPoint']  + '/' + this.apiInitial[subUrlKey];
    }

    // Setting url if initaize with v1
    private setUrlWithV1Prefix(subUrlKey: string) {
        return this.apiInitial['apiPoint'] + '/' + this.apiInitial[subUrlKey];
    }



    getRequestedResponse( initialUrl: string, proposalId: string, uuid: string,  productModuleName: string, queryJsonName?: string, insurer?: string, product?: string ) {

        const url = this.setUrlWithPrefix('apiV2')
                    + initialUrl + '/' + proposalId + '/' +  queryJsonName  + '?uuid=' + uuid  + insurer  + product ;

        return this.httpService.getRequest(url, productModuleName)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }

    getDataInfo(url, headers){
        return this.httpService.getRequest(url, headers)
        .pipe(
            map(response => response),
            catchError(err => JSON.stringify(this.errorHandler(err)))
        );
    }

    postDataInfo(url, headers, data){
        return this.httpService.postRequest(url, headers , data)
        .pipe(
            map(response => response),
            catchError(err => JSON.stringify(this.errorHandler(err)))
        );
    }

    emailComparison(url, headers, data: any) {
        return this.httpService.postRequest(url, headers, data)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(this.errorHandler(err)))
            );
    }




    /**
     * handling error coming from api
     */

    errorHandler(err) {

        /**
         * handling error case for coverage age
         * this has been done to restrict popup as current flow for
         * plan details is not acceptable fromm product
         * Backend unable to identify .for that cancel button invke
         * propssoal api .So cureently for propsola UI is handling error based on key
         */

        this.setStatusEvent(err);
        if (this.modalStatus) {
            this.setStatusEvent(err);
        } else {

            let error;
            let status;
            if (err.error) {
                error = err.error;
                status = err.status;
                this.setStatusEvent (error);
            } else if (err.details) {
                error = err.detail;
                this.setStatusEvent (error);
                status = err.status;
            } else {
                error = err;
                this.setStatusEvent (error);
                status = err.status;
            }

            let resWidth;
            if (window.screen.width <= 767) {
                resWidth = '95%';
            } else {
                resWidth = 'auto';
            }

            const dialogRef = this.dialog.open(ErrorHandlerComponent, {
                width: '50%',
                height: '50%',
                minWidth: resWidth,
                data: {
                    errorData: error,
                    statusdata: status,
                    top: '7%',
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                console.log('The dialog was closed');

            });
        }



    }


}





